import { ListingModalWrapper } from "../ListingModalWrapper";
import { ListingModalMobileStoresTitle } from "./ListingModalMobileStoresTitle";
import React from "react";
import MobileStores from "../../../../global/MobileStores/MobileStores";

export const ListingModalMobileStores = () => {
  return (
    <ListingModalWrapper
      className={"flex flex-col lg:hidden px-4 space-y-5 py-8"}
    >
      <ListingModalMobileStoresTitle className={"text-center"}>
        Access this training plan & more on the Pod1um app
      </ListingModalMobileStoresTitle>

      <MobileStores className={"flex-row space-y-0 space-x-5 scale-[0.8]"} />
    </ListingModalWrapper>
  );
};
